import React from 'react';

export interface HostProps {
  /** Style of the component's host element (the `style` attribute of a design `dc-import`). */
  hostStyle?: React.CSSProperties;
}

/**
 * Base class of every Brainux component and page. It reproduces the design runtime
 * (shared/design/_assets/dc-runtime.js): `renderVals()` computes the values the view reads,
 * merged over the props, and imported components render inside a block `div.sc-host`, so the
 * DOM — and therefore every `bx-*` rule of the design system — is identical to the design files.
 */
export class DCLogic<P = Record<string, any>, S = any> extends React.Component<P & HostProps, S> {
  [key: string]: any;
  /** Pages render their own root (`main.bx-main`) without a host element. */
  static host = true;

  constructor(props: P & HostProps) {
    super(props);
    this.state = {} as S;
  }

  renderVals(): Record<string, any> {
    return {};
  }

  view(_v: any): React.ReactNode {
    return null;
  }

  render() {
    const { hostStyle, ...props } = this.props as HostProps & Record<string, any>;
    const v = { ...props, ...this.renderVals() };
    const out = this.view(v);
    if (!(this.constructor as typeof DCLogic).host) return out;
    return (
      <div className="sc-host" style={hostStyle}>
        {out}
      </div>
    );
  }
}
